(function (merchantos) {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
  merchantos.payments = merchantos.payments || {};

  /**
   * Constructor for a base payment provider object; other providers extend
   * this class
   *
   * @constructor
   */
  function BaseProvider() {
    // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
    this.type = 'base';
    // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
    this.payment = {};
  }

  /**
   * Stores the payment for processing
   *
   * @param amount {Number} The payment amount
   * @param paymentTypeID {Number} Associated with the internal payment type
   */
  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'amount' implicitly has an 'any' type.
  BaseProvider.prototype.addPayment = function addPaymentFunc(amount, paymentTypeID) {
    this.payment = {
      amount,
      paymentTypeID,
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      registerID: merchantos.session.getRegister().registerID,
      saleID: this.saleID,
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      employeeID: merchantos.session.getEmployee().employeeID,
    };
  };

  /**
   * Start a new sale for the provider; sets the sale ID and resets any payments
   *
   * @param saleID {Number} The unique ID of the sale
   */
  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'saleID' implicitly has an 'any' type.
  BaseProvider.prototype.start = function startSale(saleID) {
    if (!saleID) {
      throw new Error('Invalid sale_id');
    }
    this.saleID = saleID;
    this.payment = {};
  };

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'payments' does not exist on type 'Mercha... Remove this comment to see the full error message
  merchantos.payments.registerProvider('base', BaseProvider);
})(window.merchantos);
